// /frontend/src/api/hints.js
import api from '@/services/api';

export const hintsApi = {
  // Ungelesene Hinweise für Admin oder Lehrer laden
  // role: 'admin' | 'teacher'
  getUnread(params = { role: 'admin' }) {
    const role = (params?.role === 'teacher') ? 'teacher' : 'admin';
    const base = role === 'teacher' ? '/teacher/hints' : '/admin/hints';
    return api.get(`${base}/unread`);
  },

  // Hinweis als gelesen markieren (setzt read_at)
  markRead(id) {
    const nid = Number(id);
    if (!Number.isFinite(nid)) {
      return Promise.reject(new Error('Ungültige Hinweis-ID'));
    }
    return api.post(`/teacher-infos/${nid}/read`);
  }
};
